module.exports = __webpack_public_path__ + "static/media/1.bd5fc6d6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1.gif
// module id = 185
// module chunks = 0